import FormBase from "./base.js";

/**
 * Контроллер Заказать звонок
 **/

const FormRecall = FormBase.extend(
    {
        defaults: {}
    },
    {
        init() {
           this._super();
        },

        'input click'(el) {
            this.focus(el);
        },
    }
);

export default FormRecall;
